export const CHINESE_TRANSLATION = [
  { letter: "field", symbol: "田" },
  { letter: "hand", symbol: "手" },
  { letter: "heart", symbol: "心" },
  { letter: "i", symbol: "我" },
  { letter: "meat", symbol: "肉" },
  { letter: "mountain", symbol: "山" },
  { letter: "person", symbol: "人" },
  { letter: "right", symbol: "右" },
  { letter: "sun", symbol: "日" },
  { letter: "water", symbol: "水" },
  { letter: "woman", symbol: "女" },
];
